import { render, staticRenderFns } from "./gLogin.vue?vue&type=template&id=025b4c18&scoped=true"
import script from "./gLogin.vue?vue&type=script&lang=js"
export * from "./gLogin.vue?vue&type=script&lang=js"
import style0 from "./gLogin.vue?vue&type=style&index=0&id=025b4c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b4c18",
  null
  
)

export default component.exports